<template>
  <div 
    class="py-0" 
    id="sidebar"
    :class="{ 'sidebar-open': isHovered }"
    @mouseenter="openSidebar"
    @mouseleave="closeSidebar"
  >
    <ul>
      <li class="sidebar-logo-item">
        <div class="sidebar-logo-wrap" aria-hidden="true">
          <img :src="logoSrc" alt="logo" class="header-logo client-logo sidebar-logo" />
        </div>
      </li>
      <li
        v-for="(item, idx) in pages"
        :key="idx"
        :class="{ 
          'active-page': $route.path === item.ref || 
                        (item.ref !== '/' && $route.path.startsWith(item.ref))
        }" 
      >
        <a :href="item.ref" @click.prevent="navigateTo(item)">
          <i :class="`fa-solid fa-${resolveIcon(item)}`"></i> 
          <span>{{ item?.name }}</span> 
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Menu from '../../services/Menu'; 
import Authentication from "@/services/Authentication"

const imageContext = require.context("../../assets/imgs", false, /\.(png|jpe?g|svg)$/i);

export default {
  name: "Sidebar",
  data() {
    return {
      icono: "",
      compania : "",
      menu: "",
      home: "/#home",
      scroll: false,
      listMenu: [],
      newMenu: [],
      isHovered: false
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.scrollFunction); 
  },
  methods: {
    scrollFunction(e) {
      this.scroll = window.pageYOffset > 300; 
      e.preventDefault(); 
    },
    openSidebar() {
      this.isHovered = true;
    },
    closeSidebar() {
      this.isHovered = false;
    },
    navigateTo(item) {
      if (item.ref) {
        this.$router.push(item.ref);
      }
    },
    logout: function() {
      const obj = {
        token: "",
        username: "",
        role: "",
        expiresIn: "",
        isAuthenticated: false,
      };
      this.$store.commit("setData", obj); 
      this.$router.push("/"); 
    },
    toggleLanguage() {
      if (this.$store.state._language == "es-ES") { 
        this.$store.commit("setLang", "en-US"); 
      } else {
        this.$store.commit("setLang", "es-ES"); 
      }
    },
    resolveIcon(item) {
      const rawIcon = (item?.icon || "").toString().trim();
      if (!rawIcon) return "list";

      if (rawIcon.includes("fa-")) {
        const faToken = rawIcon
          .split(" ")
          .find((token) => token.startsWith("fa-") && token !== "fa-solid" && token !== "fa-regular" && token !== "fa-brands");
        if (faToken) return faToken.replace(/^fa-/, "");
      }

      return rawIcon;
    },
  },
  computed: {
    logoSrc() {
      const fallback = imageContext("./logo-login.png");
      if (!this.icono) return fallback;
      const candidates = [this.icono, `${this.icono}.png`, `${this.icono}.jpg`, `${this.icono}.jpeg`];
      for (const file of candidates) {
        try {
          return imageContext(`./${file}`);
        } catch (e) {
          // keep trying
        }
      }
      return fallback;
    },
    role() {
      return this.$store.state?.userRole; 
    },
    isAuthenticated() {
      return this.$store.state?.isAuthenticated; 
    },
    language() {
      return this.$store.state?._language; 
    },
    labels() {
      if (this.$store.state._language == "es-ES") { 
        return {
          pages: [
            { name: "Dashboard", ref: "/home", route: "home", roles: [], icon: "fa-solid fa-house" },
            { name: "Administrador", ref: "/administrador", route: "administrador", roles: [], icon: "lock" },
            { name: "Parametrización", ref: "/parametrizacion", route: "parametrizacion", roles: [], icon: "layer-group" },
            { name: "Cargues", ref: "/cargues", route: "cargues", roles: [], icon: "upload" },
            { name: "Consolidación", ref: "/consolidation", route: "consolidation", roles: [], icon: "list" },
          ],
        };
      } else {
        return {
          pages: [
            { name: "Dashboard", ref: "/home", route: "home", roles: [1], icon: "fa-solid fa-house" },
            { name: "Administrator", ref: "/administrador", route: "administrador", roles: [1], icon: "lock" },
            { name: "Parametrización", ref: "/parametrizacion", route: "parametrizacion", roles: [1], icon: "layer-group" },
            { name: "Charge", ref: "/cargues", route: "cargues", roles: [1], icon: "upload" },
            { name: "Consolidation", ref: "/consolidation", route: "consolidation", roles: [1], icon: "list" },
          ],
        };
      }
    },
    pages() {
      return this.newMenu?.filter((page) => { 
        return page.roles?.find((item) => { 
          return item == this.$store.state?.userRole; 
        });
      });
    },
  },
  mounted(){
    Authentication.leaParametros() 
    .then((result) => { 
      this.icono = result.data.parametros.icono 
      this.compania = result.data.parametros.compania 
    })
    .catch((err) => console.log(err))

    Menu.getAllMenu() 
    .then((res) => { 
      this.listMenu = res.data.listMenu 
      this.listMenu.forEach((elem) => { 
        let rol = elem.roles.split(',') 
        let asigRol = rol.filter((rol) => rol == this.$store.state.userRole)
        
        let objMenu = {
          'name' : elem.nombre, 
          'ref' : elem.referencia, 
          'route' : elem.ruta, 
          'roles' : asigRol,
          'icon' : elem.icono 
        }
        this.newMenu.push(objMenu) 
      })
    })
    .catch((err) => { 
      console.log(err) 
    })
  },
};
</script>

<style>
/* Estilos base del sidebar */
#sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 80px;
  background: var(--five);
  transition: 0.3s width ease;
  z-index: 1200;
  padding: 20px 16px;
  overflow-x: hidden;
  overflow-y: auto;
}

#sidebar.sidebar-open {
  width: 250px;
}

#sidebar.sidebar-open ul li {
  justify-content: flex-start;
}

#sidebar.sidebar-open ul li a {
  justify-content: flex-start;
  padding-left: 12px;
  width: 100%;
}

#sidebar.sidebar-open span {
  display: inline-block;
}

#sidebar ul {
  list-style: none;
  padding: 0;
  margin: 18px 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sidebar-logo-item {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 54px;
  margin-bottom: 16px;
}

.sidebar-logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 0;
}

.sidebar-logo {
  max-height: 50px;
  width: auto;
  object-fit: contain;
  -webkit-filter: brightness(0) invert(1) !important;
  filter: brightness(0) invert(1) !important;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.2s ease;
}

#sidebar ul li.sidebar-logo-item:hover {
  padding-left: 0 !important;
  background: transparent !important;
}

#sidebar ul li {
  width: 100%;
  margin: 5px 0;
  position: relative;
  display: flex;
  justify-content: center;
}

#sidebar ul li a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-width: 40px;
  padding: 0 8px;
  border-radius: 6px;
  transition: all 0.3s ease;
  color: #f8f7f4 !important;
  text-decoration: none;
  font-size: 0.95rem;
  cursor: pointer;
}

#sidebar ul li a i {
  color: #f8f7f4;
}

#sidebar ul li:hover a {
  background: #004d6d;
  color: #f8f7f4 !important;
}

#sidebar ul li:hover a i {
  color: #f8f7f4;
}

#sidebar ul li.active-page a {
  background: #004d6d;
  color: #f8f7f4 !important;
}

#sidebar ul li.active-page a i {
  color: #f8f7f4;
}

#sidebar ul li.active-page span {
  color: #f8f7f4;
}

#sidebar ul li a i {
  width: 24px;
  text-align: center;
  font-size: 18px;
  flex-shrink: 0;
}

#sidebar ul li a span {
  display: none;
  margin-left: 1rem;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 155px;
}

#sidebar ul li svg {
  height: 40px;
  width: 40px;
  padding: 8px;
  border-radius: 6px;
  font-size: 2rem;
  color: var(--icon);
}

#sidebar ul li::after {
  content: '';
  position: absolute;
  left: -16px;
  top: 0;
  width: 3px;
  height: 0;
  background: #f8f7f4;
  border-radius: 0 2px 2px 0;
  transition: all 400ms cubic-bezier(0.25, 1.1, 0.3, 1);
  z-index: 2;
  pointer-events: none;
}

#sidebar ul li:hover::after,
#sidebar ul li.active-page::after {
  height: 100%;
}

#sidebar ul li a,
#sidebar ul li a:focus,
#sidebar ul li a:active,
#sidebar ul li a:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

@media (max-width: 575.98px) {
  #sidebar {
    top: 0;
    bottom: auto;
    left: 0;
    width: 80px !important;
    height: 100%;
    padding: 20px 16px;
    display: flex !important;
  }

  #sidebar.sidebar-open {
    width: 250px !important;
    height: 100%;
  }

  #sidebar ul {
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: nowrap;
    margin: 18px 0 10px 0;
    padding: 0;
    width: 100%;
    align-items: center;
  }

  #sidebar ul li {
    width: 100%;
    margin: 5px 0;
    justify-content: center;
  }

  #sidebar ul li a {
    margin: 0;
    padding: 0 8px;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    color: #f8f7f4 !important;
  }

  #sidebar ul li a i {
    font-size: 18px;
    color: #f8f7f4;
  }

  #sidebar ul li:hover a {
    background: #004d6d;
    color: #f8f7f4 !important;
  }

  #sidebar ul li:hover a i {
    color: #f8f7f4;
  }

  #sidebar.sidebar-open ul li {
    justify-content: flex-start;
  }

  #sidebar.sidebar-open ul li a {
    justify-content: flex-start;
    padding-left: 12px;
    width: 100%;
  }

  #sidebar.sidebar-open span {
    display: inline-block;
    font-size: 0.9rem;
  }

  #sidebar ul li::after {
    left: -16px;
    width: 3px;
  }

  .sidebar-logo-item {
    min-height: 54px;
    margin-bottom: 16px;
  }

  .sidebar-logo {
    max-height: 50px;
  }

  #sidebar.sidebar-open .sidebar-logo {
    max-height: 50px;
  }
}
</style>